import s from './GraphTooltip.module.css'

type Props = {
  title1: string
  title2: string
  description1: string
  description2: string
}

const GraphTooltip = ({
  title1,
  title2,
  description1,
  description2,
}: Props) => {
  return (
    <div className={s.wrapper}>
      <div>
        <div className={s.title}>{title1}</div>
        <p>{description1}</p>
      </div>
      <div>
        <div className={s.title}>{title2}</div>
        <p>{description2}</p>
      </div>
    </div>
  )
}

export default GraphTooltip
